import { Button, Flex, Icon } from "@chakra-ui/react";
import { IconType } from "react-icons";

interface NavigationLink {
  text: string;
  onClick: () => void;
  icon?: IconType;
  isDisabled?: boolean;
}

interface FormNavigationLinksProps {
  links: NavigationLink[];
  gap?: number;
  justifyContent?: string;
}

function FormNavigationLinks({
  links,
  gap = 5,
  justifyContent = "space-between",
}: FormNavigationLinksProps) {
  return (
    <Flex w={"full"} justifyContent={justifyContent} gap={gap}>
      {links.map((link, index) => (
        <Button
          key={index}
          size={"xs"}
          disabled={link.isDisabled}
          variant={"ghost"}
          onClick={link.onClick}
        >
          {link.icon && <Icon as={link.icon} size={"xs"} />}
          {link.text}
        </Button>
      ))}
    </Flex>
  );
}

export default FormNavigationLinks;
